package com.yet.tetris.database

import app.cash.sqldelight.ColumnAdapter
import com.yet.tetris.domain.model.game.Difficulty
import kotlin.Long
import kotlin.String

public data class GameHistory(
  public val id: String,
  public val score: Long,
  public val linesCleared: Long,
  public val level: Long,
  public val difficulty: Difficulty,
  public val timestamp: Long,
  public val durationMs: Long,
  public val piecesPlaced: Long,
  public val maxCombo: Long,
  public val tetrisesCleared: Long,
  public val tSpinClears: Long,
  public val perfectClears: Long,
  public val hardDrops: Long,
  public val hardDropCells: Long,
  public val softDropCells: Long,
) {
  public class Adapter(
    public val difficultyAdapter: ColumnAdapter<Difficulty, String>,
  )
}
